import { render } from "./MGXYLearn.vue?vue&type=template&id=41cf27e5&scoped=true"
import script from "./MGXYLearn.vue?vue&type=script&lang=js"
export * from "./MGXYLearn.vue?vue&type=script&lang=js"

import "./MGXYLearn.vue?vue&type=style&index=0&id=41cf27e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cf27e5"]])

export default __exports__